import { useEffect, useState, async } from 'react';
import { BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import { getApp, initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, signOut  } from "firebase/auth";
import { getFirestore, collection, onSnapshot, query, orderBy, setDoc, getDocs, doc } from "firebase/firestore";
import {
  buildTree,
} from './Tree/utilities.ts';
import LogIn from './LogIn.js';
import LoginScreen from './components/LoginScreen.jsx';
import App from './App.js';
import './App.css';
import { SortableTree } from './Tree/SortableTree.tsx';

const now = new Date()

// TODO: Put this default/test data in its own file.
const defaultItems = [
  {
    id: 1,
    title: 'Long Event',
    children: [],
    start: new Date(2025, 3, 7),
    end: new Date(2025, 3, 10),
  },

  {
    id: 2,
    title: 'DTS STARTS',
    children: [],
    start: new Date(2025, 2, 13, 0, 0, 0),
    end: new Date(2025, 2, 20, 0, 0, 0),
  },

  {
    id: 3,
    title: 'DTS ENDS',
    children: [],
    start: new Date(2025, 10, 6, 0, 0, 0),
    end: new Date(2025, 10, 13, 0, 0, 0),
  },

  {
    id: 4,
    title: 'Some Event',
    children: [],
    start: new Date(2025, 3, 9, 0, 0, 0),
    end: new Date(2025, 3, 9, 0, 0, 0),
    allDay: true,
  },

  {
    id: 92,
    title: 'Some Other Event',
    children: [],
    start: new Date(2025, 3, 9, 8, 0, 0),
    end: new Date(2025, 3, 10, 11, 30, 0),
  },
  {
    id: 5,
    title: 'Conference',
    children: [],
    start: new Date(2025, 3, 11),
    end: new Date(2025, 3, 13),
    desc: 'Big conference for important people',
  },
  {
    id: 6,
    title: 'Meeting',
    children: [],
    start: new Date(2025, 3, 12, 10, 30, 0, 0),
    end: new Date(2025, 3, 12, 12, 30, 0, 0),
    desc: 'Pre-meeting meeting, to prepare for the meeting',
  },
  {
    id: 7,
    title: 'Lunch',
    children: [],
    start: new Date(2025, 3, 12, 12, 0, 0, 0),
    end: new Date(2025, 3, 12, 13, 0, 0, 0),
    desc: 'Power lunch',
  },
  {
    id: 8,
    title: 'Meeting',
    children: [],
    start: new Date(2025, 3, 12, 14, 0, 0, 0),
    end: new Date(2025, 3, 12, 15, 0, 0, 0),
  },
  {
    id: 9,
    title: 'Happy Hour',
    children: [],
    start: new Date(2025, 3, 12, 17, 0, 0, 0),
    end: new Date(2025, 3, 12, 17, 30, 0, 0),
    desc: 'Most important meal of the day',
  },
  {
    id: 10,
    title: 'Dinner',
    children: [],
    start: new Date(2025, 3, 12, 20, 0, 0, 0),
    end: new Date(2025, 3, 12, 21, 0, 0, 0),
  },
  {
    id: 11,
    children: [],
    title: 'Planning Meeting with Paige',
    start: new Date(2025, 3, 13, 8, 0, 0),
    end: new Date(2025, 3, 13, 10, 30, 0),
  },
  {
    id: 11.1,
    children: [],
    title: 'Inconvenient Conference Call',
    start: new Date(2025, 3, 13, 9, 30, 0),
    end: new Date(2025, 3, 13, 12, 0, 0),
  },
  {
    id: 11.2,
    children: [],
    title: "Project Kickoff - Lou's Shoes",
    start: new Date(2025, 3, 13, 11, 30, 0),
    end: new Date(2025, 3, 13, 14, 0, 0),
  },
  {
    id: 11.3,
    children: [],
    title: 'Quote Follow-up - Tea by Tina',
    start: new Date(2025, 3, 13, 15, 30, 0),
    end: new Date(2025, 3, 13, 16, 0, 0),
  },
  {
    id: 12,
    children: [],
    title: 'Late Night Event',
    start: new Date(2025, 3, 17, 19, 30, 0),
    end: new Date(2025, 3, 18, 2, 0, 0),
  },
  {
    id: 12.5,
    children: [],
    title: 'Late Same Night Event',
    start: new Date(2025, 3, 17, 19, 30, 0),
    end: new Date(2025, 3, 17, 23, 30, 0),
  },
  {
    id: 13,
    children: [],
    title: 'Multi-day Event',
    start: new Date(2025, 3, 20, 19, 30, 0),
    end: new Date(2025, 3, 22, 2, 0, 0),
  },
  {
    id: 14,
    children: [],
    title: 'Today',
    start: new Date(new Date().setHours(new Date().getHours() - 3)),
    end: new Date(new Date().setHours(new Date().getHours() + 3)),
  },
  {
    id: 15,
    children: [],
    title: 'Point in Time Event',
    start: now,
    end: now,
  },
  {
    id: 16,
    children: [],
    title: 'Video Record',
    start: new Date(2025, 3, 14, 15, 30, 0),
    end: new Date(2025, 3, 14, 19, 0, 0),
  },
  {
    id: 17,
    children: [],
    title: 'Dutch Song Producing',
    start: new Date(2025, 3, 14, 16, 30, 0),
    end: new Date(2025, 3, 14, 20, 0, 0),
  },
  {
    id: 18,
    children: [],
    title: 'Itaewon Meeting',
    start: new Date(2025, 3, 14, 16, 30, 0),
    end: new Date(2025, 3, 14, 17, 30, 0),
  },
  {
    id: 19,
    children: [],
    title: 'Online Coding Test',
    start: new Date(2025, 3, 14, 17, 30, 0),
    end: new Date(2025, 3, 14, 20, 30, 0),
  },
  {
    id: 20,
    children: [],
    title: 'An overlapped Event',
    start: new Date(2025, 3, 14, 17, 0, 0),
    end: new Date(2025, 3, 14, 18, 30, 0),
  },
  {
    id: 21,
    children: [],
    title: 'Phone Interview',
    start: new Date(2025, 3, 14, 17, 0, 0),
    end: new Date(2025, 3, 14, 18, 30, 0),
  },
  {
    id: 22,
    children: [],
    title: 'Cooking Class',
    start: new Date(2025, 3, 14, 17, 30, 0),
    end: new Date(2025, 3, 14, 19, 0, 0),
  },
  {
    id: 23,
    children: [],
    title: 'Go to the gym',
    start: new Date(2025, 3, 14, 18, 30, 0),
    end: new Date(2025, 3, 14, 20, 0, 0),
  },
  {
    id: 24,
    children: [],
    title: 'DST ends on this day (Europe)',
    start: new Date(2025, 9, 30, 0, 0, 0),
    end: new Date(2025, 9, 30, 4, 30, 0),
  },
  {
    id: 25,
    children: [],
    title: 'DST ends on this day (America)',
    start: new Date(2025, 10, 6, 0, 0, 0),
    end: new Date(2025, 10, 6, 4, 30, 0),
  },
  {
    id: 26,
    children: [],
    title: 'DST starts on this day (America)',
    start: new Date(2025, 2, 12, 0, 0, 0),
    end: new Date(2025, 2, 12, 4, 30, 0),
  },
  {
    id: 27,
    children: [],
    title: 'DST starts on this day (Europe)',
    start: new Date(2025, 2, 26, 0, 0, 0),
    end: new Date(2025, 2, 26, 4, 30, 0),
  },
  {
    id: 28,
    title: 'Home',
    children: [],
    start: new Date(2025, 3, 13, 15, 30, 0),
    end: new Date(2025, 3, 13, 16, 0, 0),
  },
  {
    id: 29,
    title: 'Test',
    children: [],
    start: new Date(new Date().setHours(new Date().getHours() - 3)),
    end: new Date(new Date().setHours(new Date().getHours() + 3)),
  },
  {
    id: 30,
    title: 'Collections',
    children: [
      {id: 'Spring', children: [], start: new Date(), end: new Date()},
      {id: 'Summer', children: []},
      {id: 'Fall', children: []},
      {id: 'Winter', children: []},
    ],
    start: new Date(new Date().setHours(new Date().getHours() - 2)),
    end: new Date(new Date().setHours(new Date().getHours() + 4)),
  },
  {
    id: 31,
    title: 'About Us',
    children: []
  },
  {
    id: 32,
    title: 'My Account',
    children: [
      {id: 'Addresses', children: []},
      {id: 'Order History', children: []},
    ],
  },
];

function loadDataFromDatabase(setItems) {

  const dbOpenRequest = window.indexedDB.open("TasksDB",1);

  let db;// = dbOpenRequest.result;
  let storedItems =  null;

  dbOpenRequest.onerror = (event) => {
    console.error(`Database error: ${event.target.error?.message}`);
    alert("There was a problem connecting to your local database.");
  };

  dbOpenRequest.onsuccess = (event) => {
    db = event.target.result;
    console.log('DB connection opened for initial reading.');

    // This assumes the objectStore has already been successfully created int the DB
    // TODO: handle the exception if not.
    const objectStore = db
    .transaction("TaskNestedLists", "readonly")
    .objectStore("TaskNestedLists");
  
    const storedItemsRequest = objectStore.get(1);
    storedItemsRequest.onsuccess = (event) => {
      console.log('Initial DB Item request was successful');
      storedItems = event.target.result;
      console.log('Items obtained from DB: '+storedItems);

      if(storedItems) {
        setItems(storedItems);
      }
      else {
        setItems([]);
      };
      // flattenTree(storedItems).forEach((item) =>{ setTask(item)});
    }
    
  };

  dbOpenRequest.onupgradeneeded = (event) => {
    // Do something with request.result!
    db = event.target.result;
    alert("\nWelcome to TAOIS.\n\nYour new local database will be initialised.");  

    const objectStore = db.createObjectStore("TaskNestedLists",  { keypath: false, autoIncrement: false });
    
    // Wait for objectStore to be created.
    objectStore.transaction.oncomplete = (event) => {
      const objectStore = db
      .transaction("TaskNestedLists", "readonly")
      .objectStore("TaskNestedLists");
    }  

  };

}


// Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDEbQ4A0KKsJC4jV2Ft6zVamrTLOiA2TqM",
  authDomain: "taois-test.firebaseapp.com",
  projectId: "taois-test",
  storageBucket: "taois-test.firebasestorage.app",
  messagingSenderId: "504446620592",
  appId: "1:504446620592:web:2e1d2056c8b93f90febc75",
  measurementId: "G-F13E81LXTN"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialise Auth
const auth = getAuth(firebaseApp);


const handleSignOut = () => {
  signOut(auth)
    .then(() => {
      // Sign-out successful.
      console.log("User signed out successfully.");
    })
    .catch((error) => {
      // An error happened.
      console.error("Error signing out:", error);
    });
};

// console.log(app);
// const analytics = getAnalytics(app);

const db = getFirestore(firebaseApp);
// console.log(db);

// try {
//   const docRef = await addDoc(collection(db, "projects"), {
//     name: "TAOIS Projects",
//     createdAt: new Date(),
//     });
//   console.log("Document written with ID: ", docRef.id);
// } catch (e) {
//   console.error("Error adding document: ", e);
// }

async function setItemsFromFirebase(setItems) {
      const q = query(collection(db, "tasks"), orderBy("index"));
      const querySnapshot = await getDocs(q);
      setItems(buildTree( querySnapshot.docs.map(doc => (
        doc.data()
      ))));
}

async function setTask(task) {

  const taskDocRef = await doc(db, "tasks", task.id);

  console.log("What task ref is returned??: ", taskDocRef);

  // if(taskDocRef) {
    try {

      // const updatedDocRef = await setDoc(taskDocRef, task);
      const setDocRef = await setDoc(taskDocRef, task);

      // console.log("Document written with ID: ", updatedDocRef.id);
      console.log("Document set with ID: ", setDocRef);
    } catch (e) {
      console.error("Error updating tasks: ", e);
      // try {

      //   // const updatedDocRef = await updateDoc(taskDocRef, task);

      //   const docRef = await addDoc(collection(db, "tasks"), task);

      //   console.log("Document written with ID: ", docRef.id);
      // } catch (e) {
      //   console.error("Error adding document: ", e);
      // }
    }

  // }
  // else {
    // try {

    //   // const updatedDocRef = await updateDoc(taskDocRef, task);

    //   const docRef = await addDoc(collection(db, "tasks"), task);

    //   console.log("Document written with ID: ", docRef.id);
    // } catch (e) {
    //   console.error("Error adding document: ", e);
    // }

  // }  

}



function SuperApp() {

  const startOfWeekDateTime = new Date(Date.now());  
  const endOfWeekDateTime = new Date(Date.now());
  endOfWeekDateTime.setDate(startOfWeekDateTime.getDate()+7);

  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("Authenticated") === true);
  const [items, setItems] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const [taskDataHistory, setTaskDataHistory] = useState([]); // Your undo stack

  const updateItems = (updatedData) => {
    // Push a shallow copy of the current state onto the stack
    setTaskDataHistory(prev => ([...prev, structuredClone(items)].slice(-20))); 
    console.log("We making history? History length: " + taskDataHistory.length);
    setItems(updatedData);
  };

  const handleUndo = () => {
    if (taskDataHistory.length === 0) return;
    
    const previousTaskDataState = taskDataHistory[taskDataHistory.length - 1];
    setTaskDataHistory(prev => (prev.slice(0, -1))); // Pop the top item off
    setItems(previousTaskDataState);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check if Z is pressed alongside Ctrl (Windows) or Cmd (Mac)
      const isUndoPressed = (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'z';
      
      console.log("Key down!!: "+event.ctrlKey+' '+event.key.toLowerCase());

      if (isUndoPressed) {
        // Don't trigger if the user is actively typing in a text field
        const activeEl = document.activeElement;
        const isTyping = activeEl && (
          activeEl.tagName === 'INPUT' || 
          activeEl.tagName === 'TEXTAREA' || 
          activeEl.isContentEditable
        );
        
        if (isTyping) {
          // Let the browser handle native text undo inside the active field
          return;
        }
        
        // Trigger your structural tree undo
        event.preventDefault();
        handleUndo();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [taskDataHistory]); // Re-bind when history stack updates
  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          // User is signed in. You can check if the provider is Google
          const isGoogleUser = user.providerData.some(
            (provider) => provider.providerId === "google.com"
          );
          localStorage.setItem("Authenticated", true);
          console.log("Logged in with Google:", isGoogleUser);
          setIsLoggedIn(true);
          // localStorage.setItem("Authenticated", true);
        } else {
          localStorage.setItem("Authenticated", false);
          setIsLoggedIn(false);
            // No user is signed in
        }

      });
      
      return () => unsubscribe();

  }, [] );

  useEffect(() => {
    if(isLoggedIn) {
      console.log('About to attempt to load data.');
      loadDataFromDatabase(setItems);
      // const querySnapshot =  getDocs(collection(db, "tasks"));
      // setItems(buildTree(querySnapshot));
      // setItemsFromFirebase(setItems);
    }
    
  }, [isLoggedIn]);

  if(items){
    console.log('Passing items loaded from local database (indexedDB) to UI');
  } 
  else {
    console.log('No locally stored items loaded.');
    // setItems(defaultItems);console.log('Setting default items for use with UI');
  }

  return (
    <div>
      {/* {!isLoggedIn && <LogIn setIsLoggedIn={setIsLoggedIn} />} */}
      {!isLoggedIn && <LoginScreen setIsLoggedIn={setIsLoggedIn} auth={auth} />}
      {isLoggedIn && (
        <BrowserRouter>
          <Routes>
              <Route path="/" element={
                <App items={items} setItems={updateItems} selectedItem={selectedItem} setSelectedItem={setSelectedItem} specifiedCurrentUserId={auth.currentUser?.uid} signOut={handleSignOut}/>
                }>
              <Route path="/" element={<Navigate replace to="/Home" />} />
              <Route path="/_" ></Route>
              {/* //FIXME: Correct/Update property names or just use the existing 'useEffect' mechanism to replace passing these prop values.*/}
              {/* Refactor  these SortableTree componenets by wrapping them in their own compoenents */}
                <Route path="/Home" element={
                  <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={4} indicator removable home />
                  }/>
                <Route path="/Schedule" element={
                  <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={4} indicator removable />
                  }/>
                <Route path="/Planning/" element={
                  <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Yearly"/>
                  }/>

                  <Route path="/Planning/Yearly" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Yearly"/>
                  }/>
                    <Route path="/Planning/Yearly/This_Year" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Yearly"/>
                    }/>
                    <Route path="/Planning/Yearly/Next_Year" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Yearly"/>
                    }/>
                    <Route path="/Planning/Yearly/Year-Hence" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Yearly"/>
                    }/>

                  <Route path="/Planning/Quarterly" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Quarterly"/>
                  }/>
                    <Route path="/Planning/Quarterly/This_Quarter" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Quarterly"/>
                    }/>
                    <Route path="/Planning/Quarterly/Next_Quarter" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Quarterly"/>
                    }/>
                    <Route path="/Planning/Quarterly/Quarter-Hence" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Quarterly"/>
                    }/>
                    
                  <Route path="/Planning/Monthly" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Monthly"/>
                  }/>
                    <Route path="/Planning/Monthly/This_Month" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Monthly"/>
                    }/>
                    <Route path="/Planning/Monthly/Next_Month" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Monthly"/>
                    }/>
                    <Route path="/Planning/Monthly/Month-Hence" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Monthly"/>
                    }/>

                  <Route path="/Planning/Weekly" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Weekly"/>
                  }/>
                    <Route path="/Planning/Weekly/This_Week" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Weekly"/>
                    }/>
                    <Route path="/Planning/Weekly/Next_Week" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Weekly"/>
                    }/>
                    <Route path="/Planning/Weekly/Week-Hence" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable planning="Weekly"/>
                    }/>
                  
                <Route path="/Scheduling" element={
                  <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable />
                  }/>
                  <Route path="/Scheduling/Today" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable />
                    }/>
                  <Route path="/Scheduling/Tomorrow" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable />
                    }/>
                  <Route path="/Scheduling/Next_Three_Days" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable />
                    }/>
                  <Route path="/Scheduling/This_Week" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable initialEarliestEstimatedCommencementDateTime={startOfWeekDateTime.toISOString()} initialLatestEstimatedCommencementDateTime={endOfWeekDateTime.toISOString()}/>
                    }/>
                  <Route path="/Scheduling/Next_Week" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable initialEarliestEstimatedCommencementDateTime={startOfWeekDateTime.toISOString()} initialLatestEstimatedCommencementDateTime={endOfWeekDateTime.toISOString()}/>
                    }/>
                  <Route path="/Scheduling/Week-Hence" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable initialEarliestEstimatedCommencementDateTime={startOfWeekDateTime.toISOString()} initialLatestEstimatedCommencementDateTime={endOfWeekDateTime.toISOString()}/>
                    }/>
                  <Route path="/Scheduling/This_Month" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable initialEarliestEstimatedCommencementDateTime={startOfWeekDateTime.toISOString()} initialLatestEstimatedCommencementDateTime={endOfWeekDateTime.toISOString()}/>
                    }/>
                  <Route path="/Scheduling/Month-Hence" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable initialEarliestEstimatedCommencementDateTime={startOfWeekDateTime.toISOString()} initialLatestEstimatedCommencementDateTime={endOfWeekDateTime.toISOString()}/>
                    }/>
                {/* </Route> */}
                <Route path="/Review" element={
                  <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={3} indicator removable />
                  }/>
                    <Route path="/Review/Daily" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={0} indicator removable />
                    }/>
                    <Route path="/Review/Weekly" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={0} indicator removable initialEarliestEstimatedCommencementDateTime={startOfWeekDateTime.toISOString()} initialLatestEstimatedCommencementDateTime={endOfWeekDateTime.toISOString()}/>
                    }/>
                    <Route path="/Review/Monthly" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={0} indicator removable initialEarliestEstimatedCommencementDateTime={startOfWeekDateTime.toISOString()} initialLatestEstimatedCommencementDateTime={endOfWeekDateTime.toISOString()}/>
                    }/>
                    <Route path="/Review/Quarterly" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={0} indicator removable initialEarliestEstimatedCommencementDateTime={startOfWeekDateTime.toISOString()} initialLatestEstimatedCommencementDateTime={endOfWeekDateTime.toISOString()}/>
                    }/>
                    <Route path="/Review/Yearly" element={
                      <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={0} indicator removable initialEarliestEstimatedCommencementDateTime={startOfWeekDateTime.toISOString()} initialLatestEstimatedCommencementDateTime={endOfWeekDateTime.toISOString()}/>
                    }/>
                <Route path="/Goals" element={
                  <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={0} indicator removable initialItemsItemTypeIndex={2}/>
                  } />
                <Route path="/Tasks" element={
                  <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} indicator removable/>
                  }/>
                  <Route path="/Tasks/New" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} indicator removable initialTabValue={2} initialTaskStatusesIndex={1}/>
                    }/>
                  <Route path="/Tasks/Processing" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} indicator removable initialItemsStateIndex={1}/>
                    }/>
                  <Route path="/Tasks/Ready" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} indicator removable initialItemsStateIndex={2}/>
                    }/>
                  <Route path="/Tasks/Scheduled" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} indicator removable initialItemsStateIndex={3}/>
                    }/>
                  <Route path="/Tasks/In_Progress" element={
                    <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} indicator removable initialTaskStatusesIndex={4}/>
                    }/>
                <Route path="/Tasks/Recent" element={
                  <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} indicator removable initialTaskTiersIndex={0} />
                  } />
                {/* </Route> */}
                <Route path="/Table" element={
                  <SortableTree collapsible items={items} updateItems={updateItems} handleUndo={handleUndo} setSelectedItem={setSelectedItem} initialTabValue={2} indicator removable/>
                  } />
              </Route>
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default SuperApp;
